import React, { useState, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import rolesList from 'const/rolesList'
import useChannel from 'hooks/useChannel'
import {
  LeftSidebarView,
} from 'components/Sidebar'
import {
  ListItem
} from 'components/List'
import KanBoIcon from 'components/KanBoIcon'
import User from 'components/ControlledUser'
import Loader from 'components/Loader'

export function UserRoles ({
  userId,

  userRoles,
  allUsersRolesConfig,

  fetchUserRoles,
  requestAddUserRole,
  requestRemoveUserRole,
}) {
  useChannel('userRoles')
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    fetchUserRoles({
      userId,
      onEnd: () => {
        setIsLoading(false)
      }
    })
  }, [userId, fetchUserRoles])

  return (
    <LeftSidebarView
      title={
        <FormattedMessage
          id='USER_ROLES_HEADER'
          values={{
            userName: (
              <User
                text
                id={userId}
              />
            )
          }}
        />
      }
    >
      {isLoading
        ? <Loader center />
        : (
          userRoles &&
            rolesList.map(role => {
              const isAssignedByConfig = allUsersRolesConfig.includes(role.id)
              const isSelected = isAssignedByConfig || userRoles.includes(role.id)

              return (
                <ListItem
                  key={role.id}
                  icon={
                    <KanBoIcon
                      name={isSelected ? 'kanbo-16-solid-check-box-checked' : 'kanbo-16-check-box-unchecked'}
                    />
                  }
                  onClick={isAssignedByConfig ? undefined : () => {
                    if (isSelected) {
                      requestRemoveUserRole({
                        userId,
                        role: role.id,
                      })
                    } else {
                      requestAddUserRole({
                        userId,
                        role: role.id,
                      })
                    }
                  }}
                  subtitle={isAssignedByConfig ? (
                    <FormattedMessage id='USER_ROLES_ASSIGNED_BY_CONFIG' />
                  ) : undefined}
                >
                  <FormattedMessage id={role.formattedMessageId} />
                </ListItem>
              )
            })
        )
      }
    </LeftSidebarView>
  )
}

export default UserRoles
